import { Alert, Box, Stack, Typography } from '@mui/material';
import { getCustomFieldsUploadStatusData } from '../../../services/queries/MaggieCustomFieldQueries';
import { useAsync } from '../../../util/hook-utils';
import { Loader } from '../../../components/Loader/Loader';
import { EmptySection } from '../../../components/EmptySection';
import { CustomFieldsUploadStatusData } from '../../../schemas/CustomFieldsUploadStatusData.schema';
import { UploadStatusGrid } from './UploadStatusGrid';

export function UploadStatus() {
  const { data, loading, error } = useAsync(getCustomFieldsUploadStatusData, {
    id: 'upload-status',
  });

  if (!data) {
    return (
      <Box width='100%' height='100%' m='1rem'>
        {loading ? <Loader /> : error ? <Alert severity='error'>Failed to load data</Alert> : null}
      </Box>
    );
  }
  return (
    <Box width='100%'>
      <UploadStatusData data={data as CustomFieldsUploadStatusData[]} />
    </Box>
  );
}

interface IUploadStatusDataProps {
  data: CustomFieldsUploadStatusData[];
}
export function UploadStatusData({ data }: IUploadStatusDataProps) {
  const hasData = data.length > 0;
  return (
    <Typography color='text.primary' component='section' width={'100%'} p={'1rem 2rem'}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} mb={'1rem'}>
        <Typography variant={'h3'}>Upload History</Typography>
      </Stack>
      <Stack>
        {!hasData ? (
          <EmptySection title='No Upload' message='No files uploaded' />
        ) : (
          <UploadStatusGrid data={data} />
        )}
      </Stack>
    </Typography>
  );
}
